import { useRef } from 'react';

import { PUBLIC_HOME, PUBLIC_SEARCH } from 'global/public-routes.constants';
import MegaNavUnauthenticated from 'approot/shared/layout/navigation/mega/mega-nav-unauthenticated';
import { MegaNav as MegaNavStyled } from 'approot/shared/layout/navigation/mega/mega-nav.style';
import HeaderLogo from 'approot/shared/layout/header/header-logo';
import {
  HeaderInnerContainerStyled,
  HeaderSecondaryActions,
  HeaderSecondarySearch,
  HeaderStyled,
} from 'approot/shared/layout/header/header.style';
import {
  LAYOUT_NAVIGATION_ID,
  LAYOUT_SEARCH_ID,
} from 'approot/shared/layout/layout.constants';
import NavigationCtas from '../navigation-ctas';
import { useMegaNav } from './mega-nav.hooks';
import { useLayoutLinks } from '../../layout.hooks';
import { useRegionData } from 'approot/shared/region/region.apollo';
import IconSearch from 'approot/shared/icons/icon-search';

const MegaNav = () => {
  const headerNavRef = useRef<HTMLElement>(null);
  const { goToHome } = useLayoutLinks();

  const {
    regionBanner: { height },
  } = useRegionData();

  const {
    activeId,
    handleClose,
    handleOnFocus,
    handleOnClick,
    handleHeaderKeyDown,
  } = useMegaNav(headerNavRef);

  return (
    <HeaderStyled onKeyDown={handleHeaderKeyDown} top={height}>
      <HeaderInnerContainerStyled>
        <HeaderLogo
          defaultLogoLink={PUBLIC_HOME}
          onLogoClick={goToHome}
          onFocus={handleClose}
        />
        <MegaNavStyled
          activeSection={activeId}
          ref={headerNavRef}
          aria-label="Main"
          id={LAYOUT_NAVIGATION_ID}
          tabIndex={-1}
        >
          <MegaNavUnauthenticated
            activeId={activeId}
            handleOnFocus={handleOnFocus}
            handleOnClick={handleOnClick}
          />
        </MegaNavStyled>
        <HeaderSecondaryActions>
          <HeaderSecondarySearch
            to={PUBLIC_SEARCH}
            aria-label="Go to search"
            id={LAYOUT_SEARCH_ID}
            data-selector="mega-nav-search"
          >
            <IconSearch width={20} height={20} />
          </HeaderSecondarySearch>
          <NavigationCtas />
        </HeaderSecondaryActions>
      </HeaderInnerContainerStyled>
    </HeaderStyled>
  );
};

export default MegaNav;
